export const GET_STATES = "GET_STATES";